import React, { useState, useEffect } from 'react';

interface ExamTimerProps {
  durationMinutes: number;
  onExpired: () => void;
}

export const ExamTimer: React.FC<ExamTimerProps> = ({ durationMinutes, onExpired }) => {
  const [totalSeconds, setTotalSeconds] = useState(durationMinutes * 60);
  const [isWarning, setIsWarning] = useState(false);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setTotalSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setIsExpired(true);
          onExpired();
          return 0;
        }
        const newValue = prev - 1;
        // Show warning when 5 minutes left
        if (newValue <= 5 * 60) {
          setIsWarning(true);
        }
        return newValue;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [onExpired]);

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  const formatTime = (min: number, sec: number) => {
    return `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
  };

  return (
    <div
      className={`flex items-center gap-2 px-4 py-2 rounded-lg font-mono text-lg font-bold ${
        isExpired
          ? 'bg-red-100 text-red-800'
          : isWarning
          ? 'bg-yellow-100 text-yellow-800 animate-pulse'
          : 'bg-blue-100 text-blue-800'
      }`}
    >
      <span>⏱️</span>
      <span>{formatTime(minutes, seconds)}</span>
      {isExpired && <span className="text-sm ml-2">(Expired)</span>}
    </div>
  );
};

export default ExamTimer;
